import { useCallback } from 'react';
import { v4 as generateGuid } from 'uuid';
import { getAccessToken } from './AuthUtils';
import { useTranslation } from 'react-i18next';

export const correlationId = generateGuid();

export const useHttpUtils = () => {

    const { i18n } = useTranslation();

    const fetchDataAuthenticated = useCallback(async (url, method, body, signal) => {

        let accessToken = await getAccessToken();

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + accessToken,
            'X-Correlation-ID': correlationId,
            'X-Language': i18n.language
        };

        return await fetch(url,
            {
                method: method,
                headers: headers,
                body: body,
                signal: signal
            });
    }, [i18n.language]);

    const fetchBlobAuthenticated = useCallback(async (url, method, body) => {

        let accessToken = await getAccessToken();

        let headers = {
            'Authorization': 'Bearer ' + accessToken,
            'X-Correlation-ID': correlationId,
            'X-Language': i18n.language
        };

        return await fetch(url,
            {
                method: method ??= 'GET',
                headers: headers,
                body: body,
                responseType: 'blob'
            });
    }, [i18n.language]);

    const downloadFile = useCallback((blob, fileName) => {
        const a = document.createElement('a');
        a.download = fileName;
        let blobURL = window.URL.createObjectURL(blob);
        a.href = blobURL;
        const clickEvt = new MouseEvent('click',
            {
                view: window,
                bubbles: true,
                cancelable: true,
            });
        a.dispatchEvent(clickEvt);
        a.remove();

        window.URL.revokeObjectURL(blobURL);
    }, []);

    return { fetchDataAuthenticated, fetchBlobAuthenticated, downloadFile };
}